import { Link } from "gatsby"
import React, { memo } from "react"

import { BreadcrumbsContainer } from "../../styles/Components/Breadcrumbs"

import Chevron from "./assets/chevron.svg"

const Breadcrumbs = ({ data, chevron, noPadding, noMargin }) => {
  const last = data.length - 1
  return (
    <BreadcrumbsContainer
      className="breadcrumbs"
      noPadding={noPadding}
      noMargin={noMargin}
    >
      <Link to="/">Home</Link>
      {chevron ? (
        <img src={Chevron} alt="" />
      ) : (
        <p className="ml-1 mr-1 align-middle">/</p>
      )}
      {data &&
        data.map((item, index) => (
          <>
            <Link
              className={`${index === last ? "label-last" : "label"}`}
              to={item?.link}
              key={index}
            >
              {item?.strong ? (
                <strong>{item?.label}</strong>
              ) : (
                <span dangerouslySetInnerHTML={{ __html: item?.label }} />
              )}
            </Link>
            {data.length - 1 > index &&
              (chevron ? (
                <img src={Chevron} alt="" />
              ) : (
                <p className="ml-1 mr-1 align-middle">/</p>
              ))}
          </>
        ))}
    </BreadcrumbsContainer>
  )
}
export default memo(Breadcrumbs)
